import { defineMessages } from 'react-intl-next';

export const aiProactiveSettingMessages = defineMessages({
	toggleAllSuggestionsTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleAllSuggestionsTitle.non-final',
		defaultMessage: 'All suggestions',
		description:
			'This is the title displayed in the modal to allow the user to toggle all suggestions on or off',
	},
	toggleAllSuggestionsDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleAllSuggestionsDescription.non-final',
		defaultMessage: 'Toggle to turn suggested edits on or off.',
		description:
			'This is the description displayed in the modal to allow the user to toggle all suggestions on or off.',
	},
	toggleAllPanelSuggestionsTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleAllPanelSuggestionsTitle.non-final',
		defaultMessage: 'Panels',
		description:
			'This is the title displayed in the modal to allow the user to toggle all suggestions on or off',
	},
	toggleAllPanelSuggestionsDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleAllPanelSuggestionsDescription.non-final',
		defaultMessage: 'Use panels to make your message stand out.',
		description:
			'This is the description displayed in the modal to allow the user to toggle all suggestions on or off',
	},
	toggleErrorPanelTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleErrorPanelTitle.non-final',
		defaultMessage: 'Error panel',
		description:
			'This is the title displayed in the modal to allow the user to toggle error panel on or off',
	},
	toggleErrorPanelDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleErrorPanelDescription.non-final',
		defaultMessage: 'Transform text into a red error panel.',
		description:
			'This is the description displayed in the modal to allow the user to toggle error panel on or off',
	},
	toggleInfoPanelTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleInfoPanelTitle.non-final',
		defaultMessage: 'Info panel',
		description:
			'This is the title displayed in the modal to allow the user to toggle info panel on or off',
	},
	toggleInfoPanelDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleInfoPanelDescription.non-final',
		defaultMessage: 'Transform text into a blue information panel.',
		description:
			'This is the description displayed in the modal to allow the user to toggle info panel on or off',
	},
	toggleNotePanelTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleNotePanelTitle.non-final',
		defaultMessage: 'Note panel',
		description:
			'This is the title displayed in the modal to allow the user to toggle success panel on or off',
	},
	toggleNotePanelDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleNotePanelDescription.non-final',
		defaultMessage: 'Transform text into a purple note panel.',
		description:
			'This is the description displayed in the modal to allow the user to toggle success panel on or off',
	},
	toggleSuccessPanelTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleSuccessPanelTitle.non-final',
		defaultMessage: 'Success panel',
		description:
			'This is the title displayed in the modal to allow the user to toggle success panel on or off',
	},
	toggleSuccessPanelDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleSuccessPanelDescription.non-final',
		defaultMessage: 'Transform text into a green success panel.',
		description:
			'This is the description displayed in the modal to allow the user to toggle success panel on or off',
	},
	toggleWarningPanelTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleWarningPanelTitle.non-final',
		defaultMessage: 'Warning panel',
		description:
			'This is the title displayed in the modal to allow the user to toggle warning panel on or off',
	},
	toggleWarningPanelDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleWarningPanelDescription.non-final',
		defaultMessage: 'Transform text into a yellow warning panel.',
		description:
			'This is the description displayed in the modal to allow the user to toggle warning panel on or off',
	},
	toggleTableTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleTableTitle.non-final',
		defaultMessage: 'Table',
		description:
			'This is the title displayed in the modal to allow the user to toggle table on or off',
	},
	toggleTableDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleTableDescription.non-final',
		defaultMessage: 'Format content in a table to improve readability.',
		description:
			'This is the description displayed in the modal to allow the user to toggle table on or off',
	},
	toggleSplitParagraphTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleSplitParagraphTitle.non-final',
		defaultMessage: 'Paragraph break',
		description:
			'This is the title displayed in the modal to allow the user to toggle paragraph break on or off',
	},
	toggleSplitParagraphDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleSplitParagraphDescription.non-final',
		defaultMessage: 'Add paragraph breaks to separate key ideas.',
		description:
			'This is the description displayed in the modal to allow the user to toggle paragraph break on or off',
	},
	toggleFormatParagraphTitle: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleFormatParagraphTitle.non-final',
		defaultMessage: 'Enhance content',
		description:
			'This is the title displayed in the modal to allow the user to toggle enhance content on or off',
	},
	toggleFormatParagraphDescription: {
		id: 'fabric.editor.ai.proactive.moreMenu.toggleFormatParagraphDescription.non-final',
		defaultMessage: 'Suggestions for writing, lists, content structure, and spelling.',
		description:
			'This is the description displayed in the modal to allow the user to toggle format paragraph on or off',
	},
});
